
import Vue from 'vue'
import Loader from '@/components/Loader.vue'
import getPayments from '@/connectors/payments/get-payments'
import { IPayments } from '@/types/payments'
import { tableFields } from '@/services'

export default Vue.extend({
  name: 'Payments',
  components: { Loader },
  data () {
    return {
      loader: false,
      payerName: '',
      payments: [] as IPayments[],
      fields: tableFields.PAYMENTS
    }
  },
  computed: {
    idSelectedOrganization (): number {
      if (this.$store.state.profile.currentOrganization) {
        return this.$store.state.profile.currentOrganization.id
      }
      return 0
    },
    filteredPayments (): IPayments[] {
      if (this.payerName) {
        return this.payments.filter(item => item.payerName.toLowerCase().includes(this.payerName.toLowerCase()))
      }
      return this.payments
    }
  },
  watch: {
    '$store.state.profile.currentOrganization' () {
      this.getPayments()
    }
  },
  async mounted () {
    await this.getPayments()
  },
  methods: {
    async getPayments () {
      if (!this.idSelectedOrganization) {
        return
      }
      this.loader = true
      await getPayments(this.idSelectedOrganization)
        .then((res) => {
          console.log('payments', res)
          this.loader = false
          this.payments = res
        }).catch(e => {
          this.loader = false
          console.error(e.response)
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    }
  }
})
